import { DX_SCRIPT_DESER, DxScript } from "../../tastyworks/dx-script"
import type HttpClient from "../../tastyworks/http"
import {
  parseItemsResponse,
  type ItemsResponse,
} from "../../tastyworks/response"

const WEB_PLATFORM_PARAMS = { platform: "web" }

export default class DxScriptsService {
  readonly baseHttpClient: HttpClient

  constructor(baseHttpClient: HttpClient) {
    this.baseHttpClient = baseHttpClient
  }

  readonly index = async (): Promise<ItemsResponse<DxScript>> => {
    const helper = await this.baseHttpClient.get(
      "/dxscripts",
      WEB_PLATFORM_PARAMS
    )

    return parseItemsResponse(helper, DX_SCRIPT_DESER.toParser(DxScript))
  }

  readonly publicIndex = async (): Promise<ItemsResponse<DxScript>> => {
    const helper = await this.baseHttpClient.get(
      "/dxscripts-public",
      WEB_PLATFORM_PARAMS
    )

    return parseItemsResponse(helper, DX_SCRIPT_DESER.toParser(DxScript))
  }
}
